import SEO from '@ep/tools/seo';
import { resolveKnownImageSource } from '@ep/components/create/image';

const appConfig = (window?.config && typeof window.config === 'object') ? window.config : {};
const cfg = (appConfig?.routing && typeof appConfig.routing === 'object')
  ? appConfig.routing
  : ((appConfig?.branding && typeof appConfig.branding === 'object') ? appConfig.branding : {});
const dictBranding = (dic?.branding && typeof dic.branding === 'object') ? dic.branding : {};
const menuLabels = (dictBranding?.menu && typeof dictBranding.menu === 'object') ? dictBranding.menu : {};
const year = new Date().getFullYear();
const headerLogoSource = dictBranding.logoUrl || appConfig.logoUrl || 'logo.png';
const headerLogoUrl = resolveKnownImageSource(headerLogoSource, 'product');
const headerLogoAlt = dictBranding.logoAlt || appConfig.logoAlt || dictBranding.productName || 'Logo';
let topMenuController = null;

const clearPage = () => {
  document.querySelector('main')?.empty?.();
};

const buildFooterContent = () => {
  const footerTemplate = String(dictBranding.footer || '').replace('{year}', year);
  const footerCompany = dictBranding?.footerCompany && typeof dictBranding.footerCompany === 'object'
    ? dictBranding.footerCompany
    : {};
  const companyName = String(footerCompany.name || '').trim();
  const companyUrl = String(footerCompany.url || '').trim();
  const companyToken = '{company}';
  const companyIndex = footerTemplate.indexOf(companyToken);

  if (companyIndex < 0 || !companyName || !companyUrl) {
    return [{
      element: 'span',
      text: footerTemplate.replace(companyToken, companyName),
    }];
  }

  return [
    { element: 'span', text: footerTemplate.slice(0, companyIndex) },
    {
      element: 'a',
      class: 'footer-company-link',
      href: companyUrl,
      text: companyName,
      target: '_blank',
      rel: 'noopener noreferrer',
    },
    { element: 'span', text: footerTemplate.slice(companyIndex + companyToken.length) },
  ];
};


SEO(dictBranding.seo);

const handleBeforeTopRoute = async () => {
  clearPage();
};

const handleAfterTopRoute = async ({ routeKey }) => {
  if (routeKey === 'modules') {
    document.getElementById('header-signup-button')?.disable();
  } else {
    document.getElementById('header-signup-button')?.enable();
  }
};

await create([
  {
    element: 'div',
    parent: 'header',
    class: 'header-content',
    content: [
      {
        element: 'a', href: '/', class: 'brand-link', content: [
          { element: 'image', origin: 'external', src: headerLogoUrl, alt: headerLogoAlt, hasFigure: false, class: 'header-logo' },
        ]
      },
      {
        element: 'menu',
        type: 'top',
        config: cfg,
        dic: dictBranding,
        topRouting: {
          initialSlugFromSessionKey: 'routeSlug',
        },
        beforeRoute: handleBeforeTopRoute,
        afterRoute: handleAfterTopRoute,
        onReady: (controller) => {
          topMenuController = controller || null;
        },
      },
      {
        element: 'div',
        class: 'buttonbar',
        content: [
          {
            element: 'button',
            id: 'header-signup-button',
            text: menuLabels.signup || 'Cadastre-se',
            mode: 'header-filled',
            click: async () => {
              await topMenuController?.navigateTop?.('modules', {
                exposeSlug: cfg?.showSlug !== false,
                beforeRoute: handleBeforeTopRoute,
                afterRoute: handleAfterTopRoute,
                analytics: true,
              });
            }
          },
          {
            element: 'button',
            id: 'header-login-button',
            text: menuLabels.login || 'Login',
            mode: 'header-soft',
            click: async () => {
              if (cfg?.showSlug === false) {
                topMenuController?.route?.hidePublicRouteInAddressBar?.();
              }
              clearPage();
              document.getElementById('header-login-button')?.disable();
              const { default: login } = await import('./unlogged/login');
              login();
            }
          }
        ]
      }
    ]
  },
  {
    element: 'div', parent: 'footer', content: buildFooterContent(),
  }
]);
